export const SET_PAYROLL_DATA = "SET_PAYROLL_DATA";
export const SET_PAYROLL_OPTIONS = "SET_PAYROLL_OPTIONS";
export const SET_PAYROLL_ID = "SET_PAYROLL_ID";
